import React, { useContext, useReducer } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { getRoute } from "./helpers/utils";

import ApplicationReducer from "./reducers";
import ApplicationContext from "./context/index";

import MainLayout from "./components/layout/index";

import Lead from "./views/lead";
import BuyflowProductSelection from "./views/buyflow/product";
import BuyflowApplicationDetails from "./views/buyflow/application";

import BuyflowOverview from "./views/buyflow/overview";

import BuyflowHealthDeclaration from "./views/buyflow/health/declaration";
import BuyflowHealthAssessment from "./views/buyflow/health/assessment";
import BuyflowDeclaration from "./views/buyflow/health/customer-declaration";

import BuyflowGuideline from "./views/buyflow/guideline";
import BuyflowCustomerEkyc from "./views/buyflow/ekyc";
import BuyflowCustomerEkycPartner from "./views/buyflow/ekyc-partner";
import BuyflowCustomerDetails from "./views/buyflow/customer";
import BuyflowFinancialUnderwriting from "./views/buyflow/financial-underwriting";
import BuyflowReGenerateBI from "./views/buyflow/regenerate-bi";
import BuyflowBankDetails from "./views/buyflow/bank-details";
import BuyflowDedupe from "./views/buyflow/dedupe";
import BuyflowExistingPolices from "./views/buyflow/existing-policies";

import BuyflowProposalDetails from "./views/buyflow/proposal";
import BuyflowNomineeDetails from "./views/buyflow/nominee";
import BuyflowReviewDetails from "./views/buyflow/review";

import BuyflowBankMandate from "./views/buyflow/mandate";
import BuyflowPayment from "./views/buyflow/payment";
import BuyflowPaymentSuccess from "./views/buyflow/payment/success";
import BuyflowPaymentFailed from "./views/buyflow/payment/failed";

import BuyflowApplicationSubmission from "./views/buyflow/insta-confirmation/submission";
import BuyflowInstaConfirmation from "./views/buyflow/insta-confirmation";
import BuyflowApplicationTerminated from "./views/buyflow/terminated";

// import BuyflowLayout from "./components/layout/buyflow";
// import BuyflowApplicationVerification from "./views/buyflow/verification";
// import KnowledgeHub from "./views/drawer/knowledgeHub";
// import BuyflowDashboard from "./views/buyflow/dashboard";
// import Proposals from "./views/drawer/proposals";
// import Policies from "./views/drawer/policies";

const RouteWithLayout = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <Component {...props} />
      </Layout>
    )}
  />
);

function Routes() {
  const initialReducerState = useContext(ApplicationContext);
  const [state, dispatch] = useReducer(ApplicationReducer, initialReducerState);

  return (
    <Router>
      <Switch>
        <ApplicationContext.Provider value={{ state, dispatch }}>
          {/* Lead Section Route */}
          <RouteWithLayout
            path={getRoute("home")}
            exact
            layout={MainLayout}
            component={Lead}
          />
          {/* Buyflow Section Routes */}
          <RouteWithLayout
            path={getRoute("product")}
            exact
            layout={MainLayout}
            component={BuyflowProductSelection}
          />
          <RouteWithLayout
            path={getRoute("application")}
            exact
            layout={MainLayout}
            component={BuyflowApplicationDetails}
          />
          <RouteWithLayout
            path={getRoute("ekyc")}
            exact
            layout={MainLayout}
            component={BuyflowCustomerEkyc}
          />
          <RouteWithLayout
            path={getRoute("ekycPartner")}
            exact
            layout={MainLayout}
            component={BuyflowCustomerEkycPartner}
          />
          <RouteWithLayout
            path={getRoute("customer")}
            exact
            layout={MainLayout}
            component={BuyflowCustomerDetails}
          />
          <RouteWithLayout
            path={getRoute("dedupe")}
            exact
            layout={MainLayout}
            component={BuyflowDedupe}
          />
          <RouteWithLayout
            path={getRoute("existingPolicies")}
            exact
            layout={MainLayout}
            component={BuyflowExistingPolices}
          />
          <RouteWithLayout
            path={getRoute("financialUnderwriting")}
            exact
            layout={MainLayout}
            component={BuyflowFinancialUnderwriting}
          />
          <RouteWithLayout
            path={getRoute("regenerateBI")}
            exact
            layout={MainLayout}
            component={BuyflowReGenerateBI}
          />
          <RouteWithLayout
            path={getRoute("bankDetails")}
            exact
            layout={MainLayout}
            component={BuyflowBankDetails}
          />
          <RouteWithLayout
            path={getRoute("healthDeclaration")}
            exact
            layout={MainLayout}
            component={BuyflowHealthDeclaration}
          />
          <RouteWithLayout
            path={getRoute("healthAssessment")}
            exact
            layout={MainLayout}
            component={BuyflowHealthAssessment}
          />
          <RouteWithLayout
            path={getRoute("declaration")}
            exact
            layout={MainLayout}
            component={BuyflowDeclaration}
          />
          <RouteWithLayout
            path={getRoute("guideline")}
            exact
            layout={MainLayout}
            component={BuyflowGuideline}
          />
          <RouteWithLayout
            path={getRoute("proposalDetails")}
            exact
            layout={MainLayout}
            component={BuyflowProposalDetails}
          />
          <RouteWithLayout
            path={getRoute("nominee")}
            exact
            layout={MainLayout}
            component={BuyflowNomineeDetails}
          />
          <RouteWithLayout
            path={getRoute("reviewDetails")}
            exact
            layout={MainLayout}
            component={BuyflowReviewDetails}
          />
          <RouteWithLayout
            path={getRoute("mandate")}
            exact
            layout={MainLayout}
            component={BuyflowBankMandate}
          />
          <RouteWithLayout
            path={getRoute("payment")}
            exact
            layout={MainLayout}
            component={BuyflowPayment}
          />
          <RouteWithLayout
            path={getRoute("paymentSuccess")}
            exact
            layout={MainLayout}
            component={BuyflowPaymentSuccess}
          />
          <RouteWithLayout
            path={getRoute("paymentFailed")}
            exact
            layout={MainLayout}
            component={BuyflowPaymentFailed}
          />
          <RouteWithLayout
            path={getRoute("submission")}
            exact
            layout={MainLayout}
            component={BuyflowApplicationSubmission}
          />
          <RouteWithLayout
            path={getRoute("instaConfirmation")}
            exact
            layout={MainLayout}
            component={BuyflowInstaConfirmation}
          />
          <RouteWithLayout
            path={getRoute("terminated")}
            exact
            layout={MainLayout}
            component={BuyflowApplicationTerminated}
          />
          <RouteWithLayout
            path={`${getRoute("overview")}/:id`}
            exact
            layout={MainLayout}
            component={BuyflowOverview}
          />
          {/* <RouteWithLayout
            path={getRoute("verification")}
            exact
            layout={MainLayout}
            component={BuyflowApplicationVerification}
          />
          <RouteWithLayout
            path={getRoute("knowledgeHub")}
            exact
            layout={MainLayout}
            component={KnowledgeHub}
          />
          <RouteWithLayout
            path={getRoute("dashboard")}
            exact
            layout={MainLayout}
            component={BuyflowDashboard}
          />
          <RouteWithLayout
            path={getRoute("proposals")}
            exact
            layout={MainLayout}
            component={Proposals}
          />
          <RouteWithLayout
            path={getRoute("policies")}
            exact
            layout={MainLayout}
            component={Policies}
          /> */}
        </ApplicationContext.Provider>
      </Switch>
    </Router>
  );
}

export default Routes;
